<h2 mat-dialog-title class="info-popup-title">{{ data.title || "Info" }}</h2>
<mat-dialog-content>
  <div class="info-popup-text">{{ data.text }}</div>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="info-popup-close-btn" mat-button mat-dialog-close>{{ data.closeBtnText || "close" }}</button>
</mat-dialog-actions>
